// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"181":"2f0a44381ed08279","188":"2f0a44381ed08279","335":"2f0a44381ed08279","405":"2f0a44381ed08279","888":"9a6a408dd64a25e1"}[chunkId] + ".css";
};